import { useTranslation } from 'react-i18next';
import { LicenseSelfServeRenewable } from '../../stores/types/licenses.interface';
import { Button, ButtonSize, ButtonType, MODAL_TYPES, useGlobalModalContext } from '../_ui';
import SelfServiceRenewalSelectModal from './SelfServeRenewalSelectModal';

const SelfServeStartRenewal = ({
  renewables,
}: {
  renewables: Array<LicenseSelfServeRenewable>;
}) => {
  const { t } = useTranslation();
  const { showModal } = useGlobalModalContext();
  const handleLicenseRenewalClick = () => {
    showModal(MODAL_TYPES.INFO_MODAL, {
      title: t('license_renewal'),
      width: '561px',
      height: 'max-content',
      onRenderBody: () => <SelfServiceRenewalSelectModal renewables={renewables} />,
      shouldCloseOnOverlayClick: false,
    });
  };
  return (
    <Button
      onClick={handleLicenseRenewalClick}
      label={t('start_renewal')}
      size={ButtonSize.SMALL}
      type={ButtonType.PRIMARY}
    />
  );
};

export default SelfServeStartRenewal;
